module.exports = __webpack_public_path__ + "static/PriceListCover-76cb2d0aff32a3ae8a61c51f5529b0dc.jpg";